export enum CustomErrorType {
    IndexTimeout = 'IndexTimeout',
    ExportTimeout = 'ExportTimeout',
    StillInIndex = 'StillInIndex',
    SaveIndexTimeout = 'SaveIndexTimeout',
    TooManyFiles = 'TooManyFiles',
    FileTooBig = 'FileTooBig'
}
